
import React, { Fragment } from 'react'
import {AppRow,AppText} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row } from 'antd';


const apiData = [
    {attrName:'value',type:'string',defaultValue:'',remarks:''},
    {attrName:'placeholder',type:'string',defaultValue:'',remarks:'placeholder'},
    {attrName:'onChange',type:'(value: string) => void',defaultValue:'',remarks:''},
    {attrName:'readonly',type:'boolean',defaultValue:'false',remarks:'是否允许录入'}
]
export const AppTextDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、大文本输入框，需要用户界面交互时使用。<br/>
                2、引用：import {`{AppText}`} from 'qcc'<br/>
                3、demo位置：src/demo/components/AppTextDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
               
                <Row style={{padding:20}}>
                    <AppRow>
                       <div style={{width:600,height:100}}>
                        <AppText placeholder="请输入..." />
                       </div>
                    </AppRow>
                </Row>
            </div>
            
            <h1>API</h1>
             <DemoApiTable data={apiData}/>

    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppTextDemo.tsx